// extracted by mini-css-extract-plugin
export default {"asyncLoader":"AsyncAccessView__asyncLoader--G4mMknPBJThEliwQa188","text":"AsyncAccessView__text--HobtjQD7TLfZ7DUwvRgA"};